export const PLAN_LABELS = {
  MONTHLY: {
    price: 3.99,
    priceLabel: "$3.99",
    periodLabel: "/month",
    currency: "SGD",
  },
} as const;

export const CAMPAIGN_ID_PARAM = "campaign_id";

export const PLUS_DASHBOARD_PATH = "/plus";
export const PLUS_SUBSCRIPTION_PATH = "/plus/subscription";
export const PLUS_PAYMENT_METHOD_PATH = "/plus/payment-method";
export const PLUS_PROMOS_PATH = "/plus/promos";
export const PLUS_HISTORIES_PATH = "/plus/histories";
